import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { ExpenditureBudgetOrganizationForm } from './ExpenditureBudgetOrganizationForm';

type Props = ComponentProps<typeof ExpenditureBudgetOrganizationForm>;

export const ExpenditureBudgetOrganizationFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={
        drawerState.open &&
        drawerState.type === 'expenditure-budget-organization'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <ExpenditureBudgetOrganizationForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
